import { render } from "./TodoList.vue?vue&type=template&id=211a798e"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"

import "./TodoList.vue?vue&type=style&index=0&id=211a798e&lang=css"

import exportComponent from "D:\\node projects\\jsmethod\\vue-app\\homepage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__